import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=33da8ee6&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33da8ee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33da8ee6')) {
      api.createRecord('33da8ee6', component.options)
    } else {
      api.reload('33da8ee6', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=33da8ee6&scoped=true&", function () {
      api.rerender('33da8ee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crud/table/item_actions/Edit.vue"
export default component.exports